import { useLocale, type Locale } from "next-intl";
import { defaultLocale } from "@/config";
import { getLocale } from "next-intl/server";


export type Localization<T = string> = (
  & { [defaultLocale]: T }
  & { [k in Exclude<Locale, typeof defaultLocale>]?: T }
);


export type Translator = (
  <T = string>(messages: Localization<T>) => T
);


export function useInlineTranslator(overrideLocale?: Locale): Translator {
  const innerLocale = useLocale();
  const locale = overrideLocale ?? innerLocale;

  return function translate<T = string>(messages: Localization<T>) {
    return messages[locale] ?? messages[defaultLocale];
  }
}


export async function getInlineTranslator(overrideLocale?: Locale): Promise<Translator> {
  const locale = overrideLocale ?? await getLocale();

  return function translate<T = string>(messages: Localization<T>) {
    return messages[locale] ?? messages[defaultLocale];
  }
}
